let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cKc5B")).then(() => parcelRequire('awyal'));